const login: { [key: string]: any } = {
    "Auth.form.error.invalid": "E-mail ou senha inválidos",
};

export default login;
